import { TZDate } from '@date-fns/tz';

// This function returns the current timestamp in the format "YYYY-MM-DD HH:mm:ss" in UTC + 1 hour.
export const getCurrentTimestamp = () => {
    const date = new TZDate();

    // Adjust the date to UTC + 1 hour
    date.setUTCHours(date.getUTCHours() + 1);

    const pad = (n: number) => n.toString().padStart(2, '0');

    return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())} ` +
            `${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}:${pad(date.getUTCSeconds())}`;
};

export function convertToHours(value: string): number {
    const lower = value.toLowerCase().trim();
    
    // Handle "2 minutes or less" explicitly
    if (lower.includes("minutes or less")) {
        return +(2 / 60).toFixed(2);
    }
    
    // Handle "minutes" values
    const minuteMatch = lower.match(/^(\d+)\s*minutes?/);
    if (minuteMatch) {
        const minutes = parseInt(minuteMatch[1], 10);
        return +(minutes / 60).toFixed(2); // round to 2 decimal places
    }
    
    // Handle "hour" or "hours" values
    const hourMatch = lower.match(/^(\d+)\s*hours?/);
    if (hourMatch) {
        return parseInt(hourMatch[1], 10);
    }
    
    console.warn(`Unrecognized time format: "${value}"`);
        return 0;
}